import { ShieldCheck, ShieldAlert, CircleOff } from 'lucide-react';
import { getProductionStatus, useQuery } from '@/data';

/**
 * Global integration health (Module 01).
 * Driven from real Production integration status — never a hardcoded "Standalone" lie.
 */
export function EnvironmentBadge() {
  const { data, loading } = useQuery(getProductionStatus, []);

  if (loading && !data) {
    return (
      <span className="hidden items-center gap-1.5 rounded-full border border-line bg-surface-muted px-2.5 py-1 text-xs font-medium text-ink-muted sm:inline-flex">
        Checking Cloud…
      </span>
    );
  }

  const state = data?.state;
  const unavailable = Boolean(data && 'unavailable' in data && (data as { unavailable?: boolean }).unavailable);

  if (!state || state === 'disabled' || state === 'integration_disabled') {
    return (
      <span
        title="Production integration is disabled in this environment."
        className="hidden items-center gap-1.5 rounded-full border border-line bg-surface-muted px-2.5 py-1 text-xs font-medium text-ink-secondary sm:inline-flex"
      >
        <CircleOff size={13} aria-hidden="true" />
        Cloud integration off
      </span>
    );
  }

  if (state === 'connected' && !unavailable) {
    return (
      <span
        title="Central Admin is connected to Quds POS Cloud for management operations."
        className="hidden items-center gap-1.5 rounded-full border border-success/30 bg-success-soft px-2.5 py-1 text-xs font-medium text-success sm:inline-flex"
      >
        <ShieldCheck size={13} aria-hidden="true" />
        Cloud POS integration ready
      </span>
    );
  }

  return (
    <span
      title="Production integration is configured but currently unavailable or degraded."
      className="hidden items-center gap-1.5 rounded-full border border-warning/30 bg-warning-soft px-2.5 py-1 text-xs font-medium text-warning sm:inline-flex"
    >
      <ShieldAlert size={13} aria-hidden="true" />
      Cloud POS unavailable
    </span>
  );
}
